(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  /* Quantity cap. Enforced here, not via min/max: the checkout button sits in
     the SAME form as the updates[] fields, so a constraint-invalid field would
     block the purchase too. */
  (function () {
    var form = document.querySelector('.cart-page__form');
    if (!form) return;

    /* Lines over the cap (data-qty-clamp, unique pieces only): set each to the
       cap through /cart/change.js, then reload with the true amounts. No reload
       unless the cart holds no line over the cap any more: a failed change must
       not loop. */
    var over = form.getAttribute('data-qty-clamp');
    if (over) {
      var max = parseInt(form.getAttribute('data-qty-clamp-max'), 10);
      var url = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js';
      over.split(' ').reduce(function (chain, line) {
        return chain.then(function () {
          return fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: Number(line), quantity: max })
          }).then(function (res) {
            return res.json();
          });
        });
      }, Promise.resolve()).then(function (cart) {
        if (cart && cart.items && cart.items.every(function (item) {
          return item.quantity <= max;
        })) window.location.reload();
      });
    }

    /* The line change that brings the cart closer to the wanted "Lieferzeit"
       per variant (sync = { name, drop, want: { "<variant_id>": value } },
       from the server; '' = no lead time). Returns the first line that
       disagrees as a /cart/change.js body, keeping its quantity and its other
       properties, or null when every line agrees. A property goes by an EMPTY
       value, never by an empty object (which leaves the properties of a line
       as they are). Shopify then drops it or keeps it blank; every reader
       treats blank as absent (the property list of this section, the picking
       slip of order-forward: visibleProperties). The old English name
       (sync.drop) is emptied the same way. */
    function leadTimeChange(cart, sync) {
      var items = (cart && cart.items) || [];
      for (var i = 0; i < items.length; i += 1) {
        var item = items[i];
        var key = String(item.variant_id);
        if (!Object.prototype.hasOwnProperty.call(sync.want, key)) continue;
        var want = sync.want[key];
        var props = item.properties || {};
        var have = props[sync.name] == null ? '' : String(props[sync.name]);
        var old = sync.drop && props[sync.drop] != null ? String(props[sync.drop]) : '';
        if (have === want && old === '') continue;
        var next = {};
        Object.keys(props).forEach(function (name) {
          if (name !== sync.name && name !== sync.drop) next[name] = props[name];
        });
        if (old !== '') next[sync.drop] = '';
        next[sync.name] = want;
        return { line: i + 1, quantity: item.quantity, properties: next };
      }
      return null;
    }

    /* The reloaded cart says why the customer is still on it: set right before
       a held checkout reloads the page, read once. A page that shows the note
       and reloads again for its own sync sets it once more, so the note is on
       the page the customer ends up on. Storage can be blocked (private mode,
       site data off): then there is no note, the cart works. */
    var appliedKey = 'cart-qty-applied-note';
    function rememberNote() {
      try { window.sessionStorage.setItem(appliedKey, '1'); } catch (e) {}
    }
    var appliedNote = form.querySelector('[data-qty-applied-note]');
    var noteShown = false;
    try {
      if (window.sessionStorage.getItem(appliedKey)) {
        window.sessionStorage.removeItem(appliedKey);
        if (appliedNote) { appliedNote.hidden = false; noteShown = true; }
      }
    } catch (e) {}

    /* While the sync writes, no submit: updates[] is positional, and a line
       the sync changes may move. A held checkout comes back once the sync ends
       without a reload; with a reload the cart says to click again. A sync
       that has not ended after SYNC_TIMEOUT_MS ends there, without a reload:
       a cart that does not answer must not hold the checkout for good. */
    var SYNC_TIMEOUT_MS = 4000;
    var syncing = false;
    var held = null;
    var heldCheckout = false;

    /* A line whose "Lieferzeit" does not match its quantity against the stock
       (data-leadtime-sync, set by the server only then): write the wanted value
       line by line, then reload once the cart agrees. Not while the quantity
       cap above is reloading the page. A cart that does not take a change
       (the same change comes back) or does not answer ends without a reload,
       after one request, so the page cannot loop. */
    var leadSync = over ? null : form.getAttribute('data-leadtime-sync');
    if (leadSync) {
      var sync = null;
      try { sync = JSON.parse(leadSync); } catch (e) { sync = null; }
      if (sync && sync.name && sync.want) {
        syncing = true;
        form.setAttribute('aria-busy', 'true');
        var ended = false;
        var finish = function (reload) {
          if (ended) return;
          ended = true;
          window.clearTimeout(timeout);
          if (reload) {
            if (heldCheckout || noteShown) rememberNote();
            window.location.reload();
            return;
          }
          syncing = false;
          form.removeAttribute('aria-busy');
          var again = held;
          held = null;
          heldCheckout = false;
          if (again) again.click();
        };
        var timeout = window.setTimeout(function () { finish(false); }, SYNC_TIMEOUT_MS);
        var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        var post = function (body) {
          return fetch(root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          }).then(function (res) {
            return res.ok ? res.json() : null;
          });
        };
        /* Resolves to whether the cart now agrees after at least one change. */
        var step = function (cart, changed, sent, left) {
          if (ended || !cart) return false;
          var change = leadTimeChange(cart, sync);
          if (!change) return changed;
          var body = JSON.stringify(change);
          if (body === sent || left <= 0) return false;
          return post(change).then(function (next) {
            return step(next, true, body, left - 1);
          });
        };
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (cart) { return step(cart, false, null, 10); })
          .catch(function () { return false; })
          .then(finish);
      }
    }

    /* Checkout with a quantity typed but not applied yet: apply it first (the
       update reloads the cart with its lead times), the customer then checks
       out from the updated cart, which says so.
       The update is clicked AFTER this listener, never from inside it: the
       browser drops a submit started while the form fires its submit event
       (HTML form submission algorithm, "firing submission events"); the cart
       then stayed at the old quantity and the note asked for a click that
       could never go through. The note is left by the update's own submit,
       so it is there only when that submit really went. A second checkout
       click before that is held, so one update goes. */
    var applying = false;
    form.addEventListener('submit', function (event) {
      if (syncing) {
        event.preventDefault();
        if (event.submitter) {
          held = event.submitter;
          if (event.submitter.name === 'checkout') heldCheckout = true;
        }
        return;
      }
      if (applying) {
        if (event.submitter && event.submitter.name === 'update') {
          rememberNote();
          return;
        }
        event.preventDefault();
        return;
      }
      if (!event.submitter || event.submitter.name !== 'checkout') return;
      var inputs = form.querySelectorAll('[data-qty-input]');
      var pending = false;
      for (var i = 0; i < inputs.length; i += 1) {
        if (inputs[i].value !== inputs[i].defaultValue) pending = true;
      }
      if (!pending) return;
      var update = form.querySelector('[name=update]');
      if (!update) return;
      event.preventDefault();
      applying = true;
      window.setTimeout(function () {
        update.click();
        applying = false;
      }, 0);
    });

    var note = form.querySelector('[data-qty-note]');
    var flashTimer = null;

    function flashNote() {
      if (!note) return;
      note.classList.add('cart-page__qty-note--flash');
      window.clearTimeout(flashTimer);
      flashTimer = window.setTimeout(function () {
        note.classList.remove('cart-page__qty-note--flash');
      }, 3000);
    }

    /* Writes the field back to an allowed value; returns whether it had to. */
    function clamp(input) {
      var min = parseInt(input.getAttribute('data-qty-min'), 10) || 1;
      var max = parseInt(input.getAttribute('data-qty-max'), 10) || 0;
      var value = parseInt(input.value, 10);
      if (isNaN(value) || value < min) value = min;
      if (max && value > max) value = max;
      if (String(value) === input.value) return false;
      input.value = value;
      return true;
    }

    function requestUpdate() {
      var update = form.querySelector('[name=update]');
      if (update) update.click();
    }

    form.addEventListener('click', function (event) {
      var button = event.target.closest('[data-qty-step]');
      if (!button) return;
      var input = button.parentNode.querySelector('[data-qty-input]');
      if (!input) return;

      var before = parseInt(input.value, 10);
      if (isNaN(before)) before = 1;
      input.value = before + parseInt(button.getAttribute('data-qty-step'), 10);
      if (clamp(input)) flashNote();

      /* Value unchanged (minus at 1, plus at the cap): a reload would do
         nothing, so do not send one. */
      if (parseInt(input.value, 10) === before) return;
      requestUpdate();
    });

    /* Typed values are clamped on change but NOT auto-submitted: change fires
       before submit on Enter, so the form already carries the clamped value. */
    form.addEventListener('change', function (event) {
      var input = event.target.closest('[data-qty-input]');
      if (!input) return;
      if (clamp(input)) flashNote();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var desktop = window.matchMedia('(min-width: 1024px)');
    var nav = header.querySelector('[data-mega-nav]');
    var toggle = header.querySelector('[data-menu-toggle]');
    var drawer = header.querySelector('[data-mobile-nav]');

    function focusables(container) {
      return Array.prototype.filter.call(
        container.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'),
        function (el) {
          return el.getAttribute('tabindex') !== '-1' && !el.disabled && el.offsetParent !== null;
        }
      );
    }

    /* Keep Tab inside an open modal container. */
    function trapTab(container, e) {
      var list = focusables(container);
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    /* ── Drawer ─────────────────────────────────────────────────────────── */
    function isDrawerOpen() {
      return drawer && drawer.classList.contains('mobile-drawer--open');
    }

    function openDrawer() {
      if (!drawer) return;
      drawer.inert = false;
      drawer.classList.add('mobile-drawer--open');
      document.documentElement.setAttribute('scroll-lock', '');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      var close = drawer.querySelector('[data-mobile-close]');
      if (close) close.focus();
    }

    function closeDrawer() {
      if (!isDrawerOpen()) return;
      drawer.classList.remove('mobile-drawer--open');
      drawer.inert = true;
      document.documentElement.removeAttribute('scroll-lock');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        if (toggle.offsetParent !== null) toggle.focus();
      }
    }

    if (drawer) {
      if (toggle) toggle.addEventListener('click', openDrawer);
      drawer.querySelector('[data-mobile-close]').addEventListener('click', closeDrawer);
      drawer.querySelector('[data-mobile-overlay]').addEventListener('click', closeDrawer);
      drawer.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          e.stopPropagation();
          closeDrawer();
        } else if (e.key === 'Tab') {
          trapTab(drawer.querySelector('.mobile-drawer__panel'), e);
        }
      });
      Array.prototype.forEach.call(drawer.querySelectorAll('[data-mobile-accordion-toggle]'), function (btn) {
        btn.addEventListener('click', function () {
          var sub = document.getElementById(btn.getAttribute('aria-controls'));
          var open = btn.getAttribute('aria-expanded') !== 'true';
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (sub) sub.hidden = !open;
        });
      });
    }

    /* ── Priority nav ───────────────────────────────────────────────────────
       The nav track is sized by the grid (see .header__inner): max-content
       when it fits, the leftover when it does not. So "does it fit" is simply
       scrollWidth vs clientWidth. Items are dropped from the right; dropped
       items stay in the drawer, and .header--nav-reduced brings the burger
       back so they remain reachable. */
    var items = nav ? Array.prototype.slice.call(nav.querySelectorAll('.header__nav-item')) : [];

    function fit() {
      items.forEach(function (item) { item.classList.remove('header__nav-item--hidden'); });
      header.classList.remove('header--nav-reduced');
      if (!desktop.matches || !items.length) return;
      if (nav.scrollWidth <= nav.clientWidth + 1) {
        closeDrawer();
        return;
      }
      header.classList.add('header--nav-reduced');
      var visible = items.length;
      while (visible > 0 && nav.scrollWidth > nav.clientWidth + 1) {
        visible--;
        items[visible].classList.add('header__nav-item--hidden');
      }
    }

    var frame = null;
    function scheduleFit() {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        frame = null;
        fit();
      });
    }
    fit();
    window.addEventListener('resize', scheduleFit, { passive: true });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(fit).catch(function () {});
    }

    /* ── Mega menu — hover intent + focus ───────────────────────────────── */
    var triggers = nav ? Array.prototype.slice.call(nav.querySelectorAll('[data-mega-menu-trigger]')) : [];
    var openTimer = null;
    var closeTimer = null;
    var activeItem = null;
    /* .focus() on the trigger after Escape fires focusin, which would re-open
       the panel; suppress that one re-open. */
    var suppressOpen = false;

    function setMegaState(item, open) {
      item.classList.toggle('header__nav-item--active', open);
      var link = item.querySelector('.header__nav-link');
      if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function openMega(item) {
      if (suppressOpen) return;
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      if (activeItem && activeItem !== item) setMegaState(activeItem, false);
      openTimer = setTimeout(function () {
        setMegaState(item, true);
        activeItem = item;
      }, 150);
    }

    function closeMega(item) {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        setMegaState(item, false);
        if (activeItem === item) activeItem = null;
      }, 150);
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('mouseenter', function () { openMega(trigger); });
      trigger.addEventListener('mouseleave', function () { closeMega(trigger); });
      trigger.addEventListener('focusin', function () { openMega(trigger); });
      trigger.addEventListener('focusout', function (e) {
        if (!trigger.contains(e.relatedTarget)) closeMega(trigger);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !activeItem) return;
      var link = activeItem.querySelector('.header__nav-link');
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      setMegaState(activeItem, false);
      activeItem = null;
      suppressOpen = true;
      if (link) link.focus();
      setTimeout(function () { suppressOpen = false; }, 0);
    });

    /* ── Predictive search — open/close and the fetch loop. ARIA (combobox,
       listbox, focus return) lives in snippets/predictive-search.liquid. ── */
    var search = header.querySelector('[data-predictive-search]');
    if (!search) return;

    var searchToggle = header.querySelector('[data-search-toggle]');
    var searchInput = search.querySelector('[data-predictive-search-input]');
    var searchList = search.querySelector('[data-predictive-search-list]');
    var searchEmpty = search.querySelector('[data-predictive-search-empty]');
    var searchEmptyTitle = search.querySelector('[data-predictive-search-empty-title]');
    var searchError = search.querySelector('[data-predictive-search-error]');
    var searchSuggestions = search.querySelector('[data-predictive-search-suggestions]');
    var searchFooter = search.querySelector('[data-predictive-search-footer]');
    var searchViewAll = search.querySelector('[data-predictive-search-viewall]');
    var tViewAll = search.getAttribute('data-t-view-all') || 'View all results';
    var tViewAllFor = search.getAttribute('data-t-view-all-for') || '';
    var tNoResultsFor = search.getAttribute('data-t-no-results-for') || '';
    /* Setting search_unavailable_products: last (main shop) or hide. */
    var unavailable = search.getAttribute('data-unavailable-products') || 'last';
    var debounceTimer = null;
    var lastQuery = '';

    /* The one place that decides which state is visible:
       idle | busy | results | empty | error. Suggestions (category chips)
       carry idle, too-short input, zero hits and the error case. */
    function setState(state, query) {
      var term = (query || '').trim();
      var busy = state === 'busy';
      search.classList.toggle('predictive-search--busy', busy);
      if (searchList) searchList.hidden = !(state === 'results' || busy);
      if (searchEmpty) searchEmpty.hidden = state !== 'empty';
      if (searchError) searchError.hidden = state !== 'error';
      if (searchSuggestions) searchSuggestions.hidden = state === 'results' || busy;
      if (searchEmptyTitle && state === 'empty') {
        searchEmptyTitle.textContent = term && tNoResultsFor
          ? tNoResultsFor.replace('__TERMS__', term)
          : search.getAttribute('data-t-no-results') || '';
      }
      if (searchFooter) {
        /* From two characters there is a full results page worth going to —
           also on error, it renders server-side without suggest.json. */
        var showFooter = term.length >= 2 && !busy;
        searchFooter.hidden = !showFooter;
        if (showFooter && searchViewAll) {
          searchViewAll.setAttribute('href', '/search?q=' + encodeURIComponent(term) + '&type=product' + (unavailable === 'hide' ? '&options%5Bunavailable_products%5D=hide' : ''));
          searchViewAll.textContent = tViewAllFor ? tViewAllFor.replace('__TERMS__', term) : tViewAll;
        }
      }
    }

    function openSearch() {
      search.classList.add('predictive-search--open');
      search.setAttribute('aria-hidden', 'false');
      search.inert = false;
      document.documentElement.setAttribute('scroll-lock', '');
      setState('idle', '');
      setTimeout(function () { searchInput.focus(); }, 50);
    }

    function closeSearch() {
      search.classList.remove('predictive-search--open');
      search.setAttribute('aria-hidden', 'true');
      search.inert = true;
      document.documentElement.removeAttribute('scroll-lock');
      searchInput.value = '';
      if (searchList) searchList.innerHTML = '';
      setState('idle', '');
      lastQuery = '';
    }

    if (searchToggle) searchToggle.addEventListener('click', openSearch);
    search.querySelector('[data-predictive-search-close]').addEventListener('click', closeSearch);
    search.querySelector('[data-predictive-search-overlay]').addEventListener('click', closeSearch);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && search.classList.contains('predictive-search--open')) closeSearch();
    });

    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim();
      clearTimeout(debounceTimer);
      if (query.length < 2) {
        if (searchList) searchList.innerHTML = '';
        setState('idle', query);
        lastQuery = '';
        return;
      }
      debounceTimer = setTimeout(function () {
        if (query === lastQuery) return;
        lastQuery = query;
        fetchResults(query);
      }, 300);
    });

    function fetchResults(query) {
      if (searchList) {
        searchList.innerHTML = '<div class="predictive-search__loading"><div class="predictive-search__spinner"></div></div>';
      }
      setState('busy', query);
      var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product,page,article&resources[limit]=8&resources[options][unavailable_products]=' + unavailable;
      fetch(url)
        .then(function (r) {
          /* A 5xx carries no JSON. */
          if (!r.ok) throw new Error('suggest ' + r.status);
          return r.json();
        })
        .then(function (data) {
          if (query !== lastQuery) return;
          renderResults(data, query);
        })
        .catch(function () {
          if (query !== lastQuery) return;
          if (searchList) searchList.innerHTML = '';
          setState('error', query);
        });
    }

    function renderResults(data, query) {
      var resources = data.resources && data.resources.results;
      /* No `results` is an API error, not an empty result. */
      if (!resources) {
        if (searchList) searchList.innerHTML = '';
        setState('error', query);
        return;
      }
      var products = resources.products || [];
      /* Shopify's index answered hide with the sold piece for minutes after it sold (measured 2026-10-20). */
      if (unavailable === 'hide') products = products.filter(function (p) { return p.available; });
      var pages = (resources.pages || []).concat(resources.articles || []);
      if (!products.length && !pages.length) {
        if (searchList) searchList.innerHTML = '';
        setState('empty', query);
        return;
      }

      var html = '';
      if (products.length) {
        html += '<div class="predictive-search__group">';
        html += '<p class="predictive-search__group-heading">' + escapeHtml(search.getAttribute('data-t-products') || '') + '</p>';
        html += '<div class="predictive-search__products">';
        products.forEach(function (p) {
          var img = p.image || (p.featured_image && p.featured_image.url) || '';
          html += '<a href="' + p.url + '" class="predictive-search__product">';
          html += '<span class="predictive-search__product-image">';
          if (img) {
            /* Title sits next to the thumbnail, so the image is decorative. */
            html += '<img src="' + img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=160" alt="" loading="lazy" width="64" height="80">';
          }
          html += '</span><span class="predictive-search__product-text">';
          html += '<span class="predictive-search__product-title">' + escapeHtml(p.title) + '</span>';
          if (p.price) html += '<span class="predictive-search__product-price">' + formatMoney(p.price) + '</span>';
          html += '</span></a>';
        });
        html += '</div></div>';
      }
      if (pages.length) {
        html += '<div class="predictive-search__group">';
        html += '<p class="predictive-search__group-heading">' + escapeHtml(search.getAttribute('data-t-pages') || '') + '</p>';
        html += '<div class="predictive-search__links">';
        pages.forEach(function (page) {
          html += '<a href="' + page.url + '" class="predictive-search__link">' + escapeHtml(page.title) + '</a>';
        });
        html += '</div></div>';
      }
      if (searchList) searchList.innerHTML = html;
      setState('results', query);
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    /* suggest.json returns `price` as a DECIMAL string in the shop currency
       ("898.00") — not integer cents like /products/<handle>.js. Anything with a
       decimal separator is read as major units, a bare integer as cents. */
    function toMajorUnits(value) {
      if (typeof value === 'number') return Number.isInteger(value) ? value / 100 : value;
      var str = String(value == null ? '' : value).trim().replace(/[^\d.,-]/g, '');
      if (!str) return NaN;
      var sep = Math.max(str.lastIndexOf('.'), str.lastIndexOf(','));
      if (sep === -1) {
        var cents = parseInt(str, 10);
        return isNaN(cents) ? NaN : cents / 100;
      }
      var num = parseFloat(str.slice(0, sep).replace(/[.,]/g, '') + '.' + str.slice(sep + 1));
      return isNaN(num) ? NaN : num;
    }

    function formatMoney(value) {
      var amount = toMajorUnits(value);
      if (isNaN(amount)) return '';
      var parts = Math.abs(amount).toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      var num = (amount < 0 ? '-' : '') + parts[0] + ',' + parts[1];
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      // Same order as the shop's money format (owner 2026-11-03: "1.058,00 €").
      return currency === 'EUR' ? num + ' €' : num + ' ' + currency;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;

    var viewer = gallery.querySelector('.product__gallery-viewer');
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = track ? Array.from(track.querySelectorAll('[data-gallery-slide]')) : [];
    var thumbs = Array.from(gallery.querySelectorAll('[data-thumb-index]'));
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    var captionEl = gallery.querySelector('[data-gallery-caption]');
    var countEl = gallery.querySelector('[data-gallery-count]');
    var count = slides.length;
    /* No early return when the product has no images. A `return` here killed
       everything below the gallery — variant picker, price /
       lead-time sync, ATC state, sticky bar — so on an image-less product the
       radios still moved visually while the price, the hidden variant-id input
       and the button never followed: the cart took the pre-selected variant at
       another variant's displayed price. All gallery code below is null/empty-
       safe with zero slides, so it simply does nothing. */

    /* Start on the slide the server marked active (the variant's featured
       media is not necessarily the first image). The init-time gallery filter
       used to re-sync this via goTo(); products the filter now skips (single
       variant, no SKU) would otherwise show slide N while caption, counter,
       arrows and the lightbox opener all tracked slide 0. On mobile the
       IntersectionObserver re-syncs to whatever is actually visible. */
    var currentIndex = 0;
    slides.forEach(function(s, i) {
      if (s.classList.contains('product__gallery-slide--active')) currentIndex = i;
    });
    /* The phone strip from the stylesheet (≤749px): there the track is a
       horizontal scroll-snap strip and goTo() scrolls instead of crossfading.
       Keep it equal to the stylesheet's breakpoint; a mismatch shows up as
       thumbnails or arrows that do not move the photo. */
    var isMobile = window.matchMedia('(max-width: 749px)');

    /* --- Variant data (gallery filter & ATC state; no SKU, see "Gallery keys" in the Liquid) --- */
    var productEl = document.querySelector('.product[data-variant-json]');
    var variantData = productEl ? JSON.parse(productEl.getAttribute('data-variant-json')) : [];

    function isFiltered(index) {
      return slides[index] && slides[index].classList.contains('product__gallery-slide--filtered');
    }

    function getNextVisible(fromIndex, direction) {
      var i = fromIndex + direction;
      while (i >= 0 && i < slides.length) {
        if (!isFiltered(i)) return i;
        i += direction;
      }
      return -1;
    }

    /* --- Gallery Navigation --- */
    function goTo(index) {
      if (index < 0 || index >= slides.length || isFiltered(index)) return;
      currentIndex = index;

      if (isMobile.matches) {
        slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      } else {
        slides.forEach(function(s, i) {
          s.classList.toggle('product__gallery-slide--active', i === index);
        });
      }

      updateThumbs();
      updateArrows();
      updateCaption();
    }

    /* Caption strip: names the camera angle of the visible slide and counts
       only the slides the current variant filter left visible. */
    function updateCaption() {
      if (captionEl) {
        var view = slides[currentIndex] ? (slides[currentIndex].dataset.view || '') : '';
        captionEl.textContent = view;
      }
      var visible = [];
      for (var i = 0; i < slides.length; i++) {
        if (!isFiltered(i)) visible.push(i);
      }
      if (countEl) {
        var pos = visible.indexOf(currentIndex);
        countEl.textContent = visible.length > 1 ? (pos + 1) + ' / ' + visible.length : '';
      }
      /* Strip captions (≤749px): "n / total" under every photo, counted over
         the slides the variant filter left visible. */
      visible.forEach(function(idx, n) {
        var c = slides[idx].querySelector('[data-slide-count]');
        if (c) c.textContent = visible.length > 1 ? (n + 1) + ' / ' + visible.length : '';
      });
      /* Thumb names count the same visible set ("Ansicht 1 von 2", not "von 3"
         while a hidden variant photo sits in the DOM). */
      var tpl = gallery.getAttribute('data-thumb-label') || '';
      var tplView = gallery.getAttribute('data-thumb-label-view') || '';
      thumbs.forEach(function(t) {
        var n = visible.indexOf(parseInt(t.dataset.thumbIndex));
        if (n < 0 || !tpl) return;
        var hint = t.getAttribute('data-thumb-hint');
        var label = (hint ? tplView.replace('%v', hint) : tpl).replace('%i', n + 1).replace('%n', visible.length);
        t.setAttribute('aria-label', label);
      });
    }

    function updateThumbs() {
      thumbs.forEach(function(t) {
        var idx = parseInt(t.dataset.thumbIndex);
        var isActive = idx === currentIndex;
        t.classList.toggle('product__gallery-thumb--active', isActive);
        t.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function updateArrows() {
      if (prevBtn) prevBtn.hidden = getNextVisible(currentIndex, -1) === -1;
      if (nextBtn) nextBtn.hidden = getNextVisible(currentIndex, 1) === -1;
    }

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        goTo(parseInt(this.dataset.thumbIndex));
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function() {
      var prev = getNextVisible(currentIndex, -1);
      if (prev !== -1) goTo(prev);
    });
    if (nextBtn) nextBtn.addEventListener('click', function() {
      var next = getNextVisible(currentIndex, 1);
      if (next !== -1) goTo(next);
    });

    /* Mobile scroll sync via IntersectionObserver */
    if (track) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && isMobile.matches) {
            var idx = parseInt(entry.target.dataset.index);
            if (idx !== currentIndex) {
              currentIndex = idx;
              updateThumbs();
              updateArrows();
              updateCaption();
            }
          }
        });
      }, { root: track, threshold: 0.6 });

      slides.forEach(function(slide) { observer.observe(slide); });
    }

    /* Rotating a tablet now switches gallery modes mid-session, because the
       breakpoint list carries `(orientation: portrait)`: 820x1180 is the
       scroll-snap carousel, 1180x820 is the crossfade. Before that list existed
       the mode could only flip by resizing a desktop window past 767px, which
       is why nothing ever re-synced here.
       The two modes keep their state in different places — the carousel in the
       track's scroll position, the crossfade in the --active class — so without
       this handler the switch showed the wrong photo: portrait -> landscape
       crossfaded to the stale --active slide while caption, counter and thumb
       marker still said "3 / 5"; landscape -> portrait left the track at
       scrollLeft 0 (slide 1) with currentIndex still 3. It only healed on the
       next thumb click or swipe.
       currentIndex is the single truth, and both modes are written from it.
       The scroll is a jump, not an animation: `scroll-behavior: smooth` is set
       on scrollers in critical.css, and a visible glide here would look like
       the page repairing itself. Overriding the inline property around the
       assignment is the one way that works in every browser (`behavior:
       'instant'` is still too young for older Safari). Measuring against the
       track's own left edge rather than index * width keeps it correct when the
       variant filter has hidden slides (`display: none`).
       addListener is the pre-Safari-14 spelling of addEventListener. */
    function syncGalleryMode() {
      if (!count) return;
      if (isMobile.matches && track && slides[currentIndex]) {
        var prevBehavior = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft += slides[currentIndex].getBoundingClientRect().left - track.getBoundingClientRect().left;
        track.style.scrollBehavior = prevBehavior;
      }
      slides.forEach(function(s, i) {
        s.classList.toggle('product__gallery-slide--active', i === currentIndex);
      });
      updateThumbs();
      updateArrows();
      updateCaption();
    }
    if (isMobile.addEventListener) isMobile.addEventListener('change', syncGalleryMode);
    else if (isMobile.addListener) isMobile.addListener(syncGalleryMode);

    updateThumbs();
    updateArrows();
    updateCaption();

    /* --- Hover Zoom (Desktop only) --- */
    /* `enable_zoom` now means CLICK to zoom, not hover to zoom. The old
       pointerenter/pointermove overlay magnified whatever the pointer happened
       to be over, could not be held still, was mouse-only (no keyboard path)
       and was suppressed on mobile anyway. The lightbox already renders the
       1800px asset at up to 90vw/85vh, so it is the better magnifier — the
       click handler that opens it lives with the expand button below, where
       lbOpen() and the lightbox element are in scope. */
    var enableZoom = gallery.dataset.enableZoom === 'true' && count > 0;
    if (enableZoom && viewer) viewer.setAttribute('data-zoom-enabled', '');

    /* --- Lightbox --- */
    /* The <dialog> is only rendered when the product has images. Guarded as a
       block, NOT an early return: the variant/price wiring further down must
       run for image-less products too (same dead-picker failure as above).
       `lbTrack` is declared outside the block so the gallery filter's lightbox
       mirror can null-check it either way; the inner code keeps its original
       indentation to keep the diff reviewable. */
    var lightbox = document.querySelector('[data-lightbox]');
    var lbTrack = lightbox ? lightbox.querySelector('[data-lightbox-track]') : null;
    if (lightbox) {
    var lbSlides = lbTrack ? lbTrack.querySelectorAll('.product__lightbox-slide') : [];
    var lbPrev = lightbox.querySelector('[data-lightbox-prev]');
    var lbNext = lightbox.querySelector('[data-lightbox-next]');
    var lbCounter = lightbox.querySelector('[data-lightbox-counter]');
    var lbCloseButtons = lightbox.querySelectorAll('[data-lightbox-close]');
    var lbIndex = 0;
    var lbOpener = null;

    function getVisibleLbIndices() {
      var indices = [];
      var lbSlideEls = lbTrack ? Array.from(lbTrack.querySelectorAll('.product__lightbox-slide')) : [];
      for (var i = 0; i < lbSlideEls.length; i++) {
        if (!lbSlideEls[i].classList.contains('product__lightbox-slide--filtered')) indices.push(i);
      }
      return indices;
    }

    function updateLbCounter() {
      if (!lbCounter) return;
      var visible = getVisibleLbIndices();
      var pos = visible.indexOf(lbIndex);
      if (pos === -1) pos = 0;
      var view = slides[lbIndex] ? (slides[lbIndex].dataset.view || '') : '';
      var count = visible.length > 1 ? (pos + 1) + ' / ' + visible.length : '';
      lbCounter.textContent = view && count ? view + ' · ' + count : (view || count);
      if (lbPrev) lbPrev.hidden = visible.length < 2;
      if (lbNext) lbNext.hidden = visible.length < 2;
    }

    function lbScrollTo(index, smooth) {
      if (!lbSlides[index]) return;
      lbIndex = index;
      lbSlides[index].scrollIntoView({ behavior: smooth ? 'smooth' : 'instant', block: 'nearest', inline: 'start' });
      updateLbCounter();
    }

    /* Sync lbIndex when user scrolls/swipes natively */
    if (lbTrack) {
      var lbScrollTimer;
      lbTrack.addEventListener('scroll', function() {
        clearTimeout(lbScrollTimer);
        lbScrollTimer = setTimeout(function() {
          var scrollLeft = lbTrack.scrollLeft;
          var slideWidth = lbTrack.offsetWidth;
          var visiblePos = Math.round(scrollLeft / slideWidth);
          var visible = getVisibleLbIndices();
          var newIndex = visible[visiblePos];
          if (newIndex !== undefined && newIndex !== lbIndex) {
            lbIndex = newIndex;
            updateLbCounter();
          }
        }, 50);
      });
    }

    /* `opener` gets focus back on close. A mouse click does not focus a button
       in WebKit, so document.activeElement alone left focus on <body> there. */
    function lbOpen(index, opener) {
      lbOpener = opener || document.activeElement;
      lbIndex = index;
      lightbox.showModal();
      document.body.style.overflow = 'hidden';
      /* Scroll to correct slide instantly after dialog is visible */
      requestAnimationFrame(function() {
        lbScrollTo(index, false);
      });
    }

    function lbClose() {
      lightbox.close();
    }

    /* The scroll lock is released HERE, not in lbClose(), because the dialog
       also closes on paths that never call it: ESC is handled natively by
       <dialog> and only fires `close`. Before this, pressing ESC left
       document.body.style.overflow at 'hidden' and the page could not be
       scrolled again until a reload. Hanging the reset on the event covers
       every route out — ESC, the close button, a click on the dark ground —
       instead of asking each caller to remember it. */
    lightbox.addEventListener('close', function() {
      document.body.style.overflow = '';
      if (lbOpener && lbOpener !== document.body) lbOpener.focus();
    });

    /* Open lightbox via expand button */
    gallery.querySelectorAll('[data-gallery-expand]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var slide = btn.closest('[data-gallery-slide]');
        lbOpen(slide ? parseInt(slide.dataset.index) : currentIndex, btn);
      });
    });

    /* Click-to-zoom: the photo itself opens the lightbox. Bound on the viewer
       rather than on each <img>, so it survives slide changes and variant
       filtering without rebinding — but anything that is already a control
       (the arrows, the expand button) keeps its own job, hence the button
       guard. No keyboard handler here on purpose: the expand button sits in
       the same viewer, is focusable and does exactly this, so keyboard users
       already have the path and the image does not need to become a second,
       competing tab stop. */
    if (enableZoom && viewer) {
      viewer.addEventListener('click', function(e) {
        if (e.target.closest('button')) return;
        lbOpen(currentIndex, viewer.querySelector(':scope > [data-gallery-expand]'));
      });
    }

    /* Close buttons */
    lbCloseButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        if (e.target === btn || e.target.closest('[data-lightbox-close]') === btn) {
          lbClose();
        }
      });
    });

    /* Click on the ground closes: the track fills the dialog's middle row, so
       anything on it that is not the photograph and not a control closes the
       lightbox. Swipes on touch end without a click, so the carousel is
       unaffected. */
    if (lbTrack) {
      lbTrack.addEventListener('click', function(e) {
        if (e.target.closest('.product__lightbox-img')) return;
        if (e.target.closest('button')) return;
        lbClose();
      });
    }

    /* Lightbox arrow navigation */
    if (lbPrev) lbPrev.addEventListener('click', function() {
      var visible = getVisibleLbIndices();
      var pos = visible.indexOf(lbIndex);
      if (pos === -1) return;
      lbScrollTo(visible[(pos - 1 + visible.length) % visible.length], true);
    });
    if (lbNext) lbNext.addEventListener('click', function() {
      var visible = getVisibleLbIndices();
      var pos = visible.indexOf(lbIndex);
      if (pos === -1) return;
      lbScrollTo(visible[(pos + 1) % visible.length], true);
    });

    /* Keyboard navigation */
    lightbox.addEventListener('keydown', function(e) {
      var visible = getVisibleLbIndices();
      var pos = visible.indexOf(lbIndex);
      if (pos === -1) return;
      if (e.key === 'ArrowLeft') { lbScrollTo(visible[(pos - 1 + visible.length) % visible.length], true); e.preventDefault(); }
      if (e.key === 'ArrowRight') { lbScrollTo(visible[(pos + 1) % visible.length], true); e.preventDefault(); }
      if (e.key === 'Home') { lbScrollTo(visible[0], true); e.preventDefault(); }
      if (e.key === 'End') { lbScrollTo(visible[visible.length - 1], true); e.preventDefault(); }
    });

    } /* end if (lightbox) */

    /* --- Variant selection & gallery filtering --- */
    var optionInputs = document.querySelectorAll('[data-option-index]');

    /* Filter the gallery to the selected VARIANT and switch to its image.
       The supplier SKU never reaches the page (owner decision 2026-10-15): the
       Liquid ("Gallery keys") compares each alt's SKU token with the variant
       SKUs and gives every slide variant ids instead:
         data-match-exact — the variant whose SKU IS the alt's token
         data-match-metal — the first variant with the same model code + metal
                            letter (a size sibling: the photos show this metal)
       and every variant its own two keys (gallery_key, metal_key). Almost no
       variant owns a featured_media, and on family/combined products the
       alt-SKU is a REPRESENTATIVE sibling, so exact equality alone never
       matched anything. Slides are therefore tiered:

         exact   — the slide's exact key is the variant's
         metal   — same metal key (model + metal letter)
         neutral — no metal key: no token, a token that is no decodable SKU
                   ("catalog", descriptive alts), or one no variant of THIS
                   product shares (retired sibling photo): always visible
         other   — a metal key of another variant: hidden (choosing that
                   variant reveals it again)

       Only "other" is filtered out; the switch then targets, in order:
       the variant's featured media/image > exact > metal > first visible.
       On the INIT call (isInit) the featured media is skipped: Shopify's
       auto-assigned variant image is often the family "catalog" shot sitting
       mid-gallery, and first paint then opened on "3 / 4" instead of the
       first visible slide. */
    function filterGalleryBySku(variant, isInit) {
      var exactKey = variant && variant.gallery_key;
      if (!exactKey) return;
      /* One variant → nothing to switch between: never filter, never jump.
         Every image belongs to the piece, the server-set active slide stays,
         and the counter keeps counting all of them. */
      if (variantData.length < 2) return;
      var metalKey = variant.metal_key || '';

      var tiers = slides.map(function(slide) {
        var exact = slide.dataset.matchExact || '';
        var metal = slide.dataset.matchMetal || '';
        if (exact && exact === exactKey) return 'exact';
        if (!metal) return 'neutral';
        if (metalKey && metal === metalKey) return 'metal';
        return 'other';
      });

      /* The un-suffixed "catalog" hero (alt is just "catalog", no SKU) depicts
         ONE concrete metal — the family representative's. When the current
         selection owns its own catalog shot (a "catalog-…" view behind an
         exact/metal alt-SKU), the generic one is the OTHER metal's duplicate
         and follows the metal filter like the rest; without an own catalog
         shot it stays visible, because hiding it could strip the selection of
         its only hero. Keeps thumbnail 1 from showing the wrong metal. */
      var ownCatalog = slides.some(function(slide, i) {
        var altView = slide.dataset.altView || '';
        return (tiers[i] === 'exact' || tiers[i] === 'metal') && altView.indexOf('catalog') === 0;
      });
      if (ownCatalog) {
        slides.forEach(function(slide, i) {
          if (tiers[i] === 'neutral' && slide.hasAttribute('data-catalog-generic')) tiers[i] = 'other';
        });
      }

      /* Decide first, apply second — a filter that matches NOTHING must never
         be allowed to empty the gallery. If every slide would be hidden, hide
         nothing: the shopper sees the full set instead of a grey box
         (invariant since 2026-08-15, when "catalog" alts emptied the viewer). */
      var hidden = tiers.map(function(t) { return t === 'other'; });
      if (hidden.length && hidden.indexOf(false) === -1) {
        hidden = hidden.map(function() { return false; });
      }

      slides.forEach(function(slide, i) {
        slide.classList.toggle('product__gallery-slide--filtered', hidden[i]);
        if (thumbs[i]) thumbs[i].classList.toggle('product__gallery-thumb--filtered', hidden[i]);
      });

      /* Mirror to lightbox */
      if (lbTrack) {
        var lbSlideEls = Array.from(lbTrack.querySelectorAll('.product__lightbox-slide'));
        lbSlideEls.forEach(function(lbSlide, i) {
          if (slides[i]) {
            lbSlide.classList.toggle('product__lightbox-slide--filtered', isFiltered(i));
          }
        });
      }

      /* Switch to the image that shows THIS variant. featured media wins when
         a variant actually has one (variant JSON exposes featured_media and/or
         featured_image; slides carry the image id); otherwise the alt-SKU
         tiers decide, and the plain first-visible jump stays the fallback. */
      var featIds = [];
      if (!isInit) {
        if (variant.featured_media && variant.featured_media.id) featIds.push(String(variant.featured_media.id));
        if (variant.featured_image && variant.featured_image.id) featIds.push(String(variant.featured_image.id));
      }
      var target = -1;
      var i;
      for (i = 0; i < slides.length && target === -1; i++) {
        if (!hidden[i] && featIds.indexOf(slides[i].dataset.imageId) !== -1) target = i;
      }
      /* Product shot before the worn image: within each tier the on-body slide
         is only taken when the tier has nothing else (owner rule 2026-09-15;
         since 2026-10-13 the lifestyle image is image 3 of the gallery, not the
         last one, and it still never opens a variant). */
      var isBody = function(idx) { return (slides[idx].dataset.altView || '') === 'on-body'; };
      ['exact', 'metal'].forEach(function(tier) {
        for (i = 0; i < slides.length && target === -1; i++) {
          if (!hidden[i] && tiers[i] === tier && !isBody(i)) target = i;
        }
      });
      ['exact', 'metal'].forEach(function(tier) {
        for (i = 0; i < slides.length && target === -1; i++) {
          if (!hidden[i] && tiers[i] === tier) target = i;
        }
      });
      if (target === -1) target = getNextVisible(-1, 1);
      if (target !== -1) goTo(target);

      /* The sticky-ATC thumb mirrors the slide the gallery landed on, so it
         can never keep showing the other metal after a switch. */
      var stickyImg = document.querySelector('[data-sticky-atc-img]');
      if (stickyImg && target !== -1 && slides[target].dataset.thumbSrc) {
        stickyImg.src = slides[target].dataset.thumbSrc;
      }
    }

    var addToCartBtn = productEl.querySelector('[data-add-to-cart]');
    var addToCartText = productEl.getAttribute('data-add-to-cart-text');
    var soldOutText = productEl.getAttribute('data-sold-out-text');

    /* Unavailable combinations stay on screen (dashed + struck through) and
       are NAMED unavailable: the radio's accessible name becomes "<value> –
       nicht verfügbar", from the locale template on the product element.
       The note line under the picker shows whenever one is struck through. */
    var unavailableTemplate = productEl.getAttribute('data-unavailable-label') || '[value]';
    function markUnavailable(input, off) {
      var text = input.closest('.product__option-value');
      text = text && text.querySelector('.product__option-value-text');
      var name = text ? text.textContent.trim() : input.value;
      if (off) input.setAttribute('aria-label', unavailableTemplate.replace('[value]', name));
      else input.removeAttribute('aria-label');
    }
    function updateGapNote() {
      var note = productEl.querySelector('[data-option-note]');
      if (!note) return;
      var struck = Array.prototype.some.call(
        productEl.querySelectorAll('.product__option-value--unavailable'),
        function(el) { return el.offsetParent !== null; }
      );
      note.hidden = !struck;
    }

    /* Track which option values are unavailable */
    var unavailableOptions = new Set();

    /* Check which option values are available given the other selected options */
    function updateOptionAvailability(selectedOptions) {
      unavailableOptions.clear();
      var optionGroups = productEl.querySelectorAll('.product__option');
      optionGroups.forEach(function(group) {
        var inputs = group.querySelectorAll('[data-option-index]');
        if (!inputs.length) return;
        var optIdx = parseInt(inputs[0].dataset.optionIndex);

        inputs.forEach(function(input) {
          var isAvailable = variantData.some(function(v) {
            /* A variant blocked with DENY at stock 0 (owner decision 2026-11-01) is not offered. */
            if (!v.available) return false;
            var opts = [v.option1, v.option2, v.option3];
            if (opts[optIdx] !== input.value) return false;
            for (var i = 0; i < selectedOptions.length; i++) {
              if (i === optIdx) continue;
              if (selectedOptions[i] && opts[i] !== selectedOptions[i]) return false;
            }
            return true;
          });
          var label = input.closest('.product__option-value');
          label.classList.toggle('product__option-value--unavailable', !isAvailable);
          markUnavailable(input, !isAvailable);
          if (!isAvailable) {
            unavailableOptions.add(optIdx + ':' + input.value);
          }
        });
      });
    }

    /* If a checked option became unavailable, auto-select the first available one */
    function autoCorrectOptions() {
      var changed = false;
      var optionGroups = productEl.querySelectorAll('.product__option');
      optionGroups.forEach(function(group) {
        var checked = group.querySelector('[data-option-index]:checked');
        if (checked && checked.closest('.product__option-value--unavailable')) {
          var available = group.querySelector('.product__option-value:not(.product__option-value--unavailable) [data-option-index]');
          if (available) {
            available.checked = true;
            changed = true;
          }
        }
      });
      return changed;
    }

    /* Update the add-to-cart button based on matched variant */
    function updateAddToCart(matched) {
      if (!addToCartBtn) return;
      if (matched && matched.available) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = addToCartText;
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = matched ? soldOutText : soldOutText;
      }
    }

    function getSelectedOptions() {
      var selectedOptions = [];
      productEl.querySelectorAll('[data-option-index]:checked').forEach(function(checked) {
        selectedOptions[parseInt(checked.dataset.optionIndex)] = checked.value;
      });
      return selectedOptions;
    }

    /* Echo the chosen value next to each option label, so the compound
       catalogue values ("18 kt Weißgold · Weite 54") stay readable without
       scanning the row of chips. */
    function updateSelectedLabels() {
      var groups = productEl.querySelectorAll('.product__option');
      groups.forEach(function(group, i) {
        var out = group.querySelector('[data-option-selected]');
        if (!out) return;
        var checked = group.querySelector('[data-option-index]:checked');
        out.textContent = checked ? checked.value : '';
      });
    }

    function handleOptionChange() {
      var selectedOptions = getSelectedOptions();

      /* Update which options are available */
      updateOptionAvailability(selectedOptions);

      /* Auto-correct if selected option is now unavailable */
      if (autoCorrectOptions()) {
        selectedOptions = getSelectedOptions();
        updateOptionAvailability(selectedOptions);
      }

      var matched = variantData.find(function(v) {
        return v.option1 === selectedOptions[0] &&
               (selectedOptions[1] === undefined || v.option2 === selectedOptions[1]) &&
               (selectedOptions[2] === undefined || v.option3 === selectedOptions[2]);
      });
      if (matched) {
        document.querySelector('[data-variant-id]').value = matched.id;
        var url = new URL(window.location);
        url.searchParams.set('variant', matched.id);
        window.history.replaceState({}, '', url);
      }

      updateAddToCart(matched);
      updateGapNote();
      updateSelectedLabels();
      updatePrice(matched);
      updateLeadTime(matched);
      updateCartLeadTime(matched);
      updateMtoNote(matched);
      updateFineness(matched);
      filterGalleryBySku(matched);

      updateArticleNumber(matched);
      updateRingSize(matched);
      updateSizeInquiry(matched);
    }

    /* "Größen außerhalb des Lagerbestands: …" speaks for the metal on screen:
       hidden while the chosen metal has no made-to-order size (review
       2026-10-31: in 14 kt Gelbgold 13 of 15 sizes stood struck through under
       the note, the made-to-order sizes exist in 18 kt Weißgold only). The
       metal of a variant is its option values without the size part, so a
       combined "14 kt Gelbgold · Weite 54" and separate options read alike;
       a product with a size option only has one metal (''). */
    function variantMetal(variant) {
      return [variant.option1, variant.option2, variant.option3]
        .filter(function(o) { return o != null; })
        .join(' · ')
        .split(' · ')
        .filter(function(part) {
          return !/^(?:(?:ring)?(?:weite|größe|groesse)|size)?\s*\d{2}(?:[,.]\d)?$/i.test(part.trim());
        })
        .join(' · ');
    }

    function updateMtoNote(variant) {
      var note = document.querySelector('[data-mto-note]');
      if (!note || !variant) return;
      var metal = variantMetal(variant);
      note.hidden = !variantData.some(function(v) {
        return v.lead_time_weeks && variantMetal(v) === metal;
      });
    }

    /* Ring-size inquiry link (rings only, see the Liquid above): keep the
       article number and the chosen variant in the prepared mail in step with
       the selection. The templates come from the markup, so the wording has one
       source; without JS the server-rendered href stays valid for the variant
       the page was loaded with. */
    function updateSizeInquiry(variant) {
      var link = document.querySelector('[data-size-inquiry]');
      if (!link || !variant) return;
      var article = variant.article_number || '';
      function fill(template) {
        return (template || '')
          .split('[article]').join(article)
          .split('[variant]').join(variant.title || '')
          .split('[br]').join('\r\n');
      }
      var subject = article ? link.dataset.inquirySubject : link.dataset.inquirySubjectBare;
      var body = article ? link.dataset.inquiryBody : link.dataset.inquiryBodyBare;
      link.href = link.dataset.inquiryUrl +
        '?subject=' + encodeURIComponent(fill(subject)) +
        '&body=' + encodeURIComponent(fill(body)) + '#kontaktformular';
    }

    /* The ring size of a ring without a size option follows the selection: the
       variant's own custom.ring_size, else the size read from the text
       (data-ring-size-fallback); neither hides the line. The fallback also
       serves a variant without a value next to one with a value (24 products
       on 2026-10-28, text size = its SKU size digits in all of them); the
       backfill's plan.md lists those (theme/CLAUDE.md). */
    function updateRingSize(variant) {
      var wrap = document.querySelector('[data-ring-size-wrap]');
      if (!wrap || !variant) return;
      var size = variant.ring_size || wrap.dataset.ringSizeFallback || '';
      wrap.hidden = !size;
      var el = wrap.querySelector('[data-ring-size]');
      if (el) el.textContent = size;
    }

    /* Our article number (custom.article_number) follows the selection, in the
       spec line and in the GPSR block; a variant without one hides both. Never
       the supplier SKU (owner decision 2026-10-15). */
    function updateArticleNumber(variant) {
      if (!variant) return;
      var article = variant.article_number || '';
      var wraps = document.querySelectorAll('[data-article-number-wrap]');
      for (var i = 0; i < wraps.length; i++) {
        wraps[i].hidden = !article;
        var el = wraps[i].querySelector('[data-article-number]');
        if (el) el.textContent = article;
      }
    }

    /* Keep every rendered price in step with the selected variant. Formatting is
       taken from the markup Liquid already produced (money filter, locale, currency)
       so we never re-implement it in JS: we only swap the number, using the same
       de-DE grouping the page was rendered with. */
    var moneyFormat = (function () {
      var sample = document.querySelector('.product__price .price__regular, .product__price .price__sale');
      return sample ? sample.textContent.trim() : '';
    })();

    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      var num = parts.join(',');
      /* Reuse the currency affix from the server-rendered price so a currency or
         locale change in Shopify settings does not need a code change here. */
      /* \D* on both sides keeps the spaces of the shop format ("1.058,00 €" since 2026-11-03,
         "€1.058,00" before); a class with \s inside the number ate the space before the €. */
      var m = moneyFormat.match(/^(\D*)\d[\d.,]*(\D*)$/);
      return m ? (m[1] + num + m[2]) : (num + ' €');
    }

    function updatePrice(variant) {
      if (!variant) return;
      document.querySelectorAll('.product__price .price, .product__sticky-atc-price .price').forEach(function (priceEl) {
        var regular = priceEl.querySelector('.price__regular, .price__sale');
        var compare = priceEl.querySelector('.price__compare');
        if (regular) regular.textContent = formatMoney(variant.price);
        updateFinancing(variant);
        if (compare) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compare.textContent = formatMoney(variant.compare_at_price);
            compare.hidden = false;
          } else {
            compare.hidden = true;
          }
        }
      });
    }

    /* Financing approximation line: price / 12 for the selected variant.
       The wording lives in the [data-financing-template] Liquid rendered
       ("oder ab ca. [amount]/Monat — …"), so JS only swaps the number. */
    function updateFinancing(variant) {
      if (!variant) return;
      var fin = document.querySelector('[data-financing]');
      if (!fin) return;
      var template = fin.getAttribute('data-financing-template');
      if (!template) return;
      fin.textContent = template.replace('[amount]', formatMoney(Math.round(variant.price / 12)));
    }

    /* Lead time follows the selected variant's stock. Both strings come from the
       markup so the wording stays translatable and is never duplicated in JS. */
    function updateLeadTime(variant) {
      if (!variant || !productEl) return;
      var el = document.querySelector('.product__leadtime-term');
      if (!el) return;
      /* Not buyable (DENY at stock 0): no lead time, as on the server (lead_term blank). */
      var wrap = el.closest('.product__leadtime');
      if (!variant.available) {
        wrap.hidden = true;
        return;
      }
      wrap.hidden = false;
      /* product.variants | json omits inventory_quantity, so stock comes from the
         data-stock-map Liquid emits alongside it ("id:1,id:0,…"). Without this the
         JS overwrote the correctly server-rendered term with the out-of-stock term on
         every product, whatever its stock. */
      var inStock = (productEl.getAttribute('data-stock-map') || '')
        .split(',').indexOf(String(variant.id) + ':1') !== -1;
      /* A made-to-order size names the weeks of its metafield (owner decision #7);
         the others the static "4–6 Wochen". Never a date window: review 2026-11-01, #33. */
      var weeksTemplate = productEl.getAttribute('data-leadtime-weeks');
      var weeks = variant.lead_time_weeks ? String(variant.lead_time_weeks) : '';
      /* A sold-out real variant on a product with made-to-order sizes names the
         product's weeks (owner decision #20). */
      if (!weeks && variant.backorder) weeks = productEl.getAttribute('data-leadtime-mto-weeks') || '';
      var text = null;
      if (!inStock && weeks && weeksTemplate && weeksTemplate.indexOf('[weeks]') !== -1) {
        text = weeksTemplate.replace('[weeks]', weeks);
      }
      if (!text) text = productEl.getAttribute(inStock ? 'data-leadtime-in-stock' : 'data-leadtime-made');
      if (text) el.textContent = text;
      var dot = document.querySelector('[data-leadtime-dot]');
      if (dot) dot.classList.toggle('product__leadtime-dot--later', !inStock);
    }

    /* Line item property "Lieferzeit" (owner decision #21): follows the variant
       picker. A variant out of stock (backorder) or whose next piece is beyond
       stock (over_stock: the cart holds its stock already) carries "ca. <weeks>
       Wochen": its own weeks, else the made-to-order weeks of the product, else
       4–6. Any other variant, or no variant, disables the input: not submitted. */
    function updateCartLeadTime(variant) {
      if (!productEl) return;
      var input = productEl.querySelector('[data-leadtime-property]');
      if (!input) return;
      var weeks = '';
      if (variant && (variant.backorder || variant.over_stock)) {
        weeks = variant.lead_time_weeks ? String(variant.lead_time_weeks)
          : (productEl.getAttribute('data-leadtime-mto-weeks') || input.getAttribute('data-leadtime-backorder-weeks') || '');
      }
      var template = input.getAttribute('data-leadtime-property-template') || '';
      if (weeks && template.indexOf('[weeks]') !== -1) {
        input.value = template.replace('[weeks]', weeks);
        input.disabled = false;
      } else {
        input.value = '';
        input.disabled = true;
      }
    }

    /* Feingehalt spec tile follows the selected variant. Mirrors the Liquid
       variant-bound override (same token → hallmark mapping): the option value
       ("950 Pt Platin · Weite 54") is the per-variant truth, the server-parsed
       family value is only the first paint. When no option value carries an
       alloy token (metal is not an option), the server value stays. */
    function finenessFromVariant(variant) {
      if (!variant) return '';
      var opts = [variant.option1, variant.option2, variant.option3];
      for (var i = 0; i < opts.length; i++) {
        var v = opts[i] || '';
        if (v.indexOf('Platin') !== -1 || v.indexOf('950 Pt') !== -1) return '950 Platin';
        if (v.indexOf('18 kt') !== -1) return '750 · 18 kt';
        if (v.indexOf('14 kt') !== -1) return '585 · 14 kt';
      }
      return '';
    }
    function updateFineness(variant) {
      var el = document.querySelector('[data-spec-fineness]');
      if (!el) return;
      var f = finenessFromVariant(variant);
      if (f) el.textContent = f;
    }

    optionInputs.forEach(function(input) {
      input.addEventListener('click', function(e) {
        var key = input.dataset.optionIndex + ':' + input.value;
        if (unavailableOptions.has(key)) {
          e.preventDefault();
          return;
        }
      });
      input.addEventListener('change', handleOptionChange);
    });

    /* Initialize: filter gallery + disable unavailable options for initial variant */
    var initialVariantId = parseInt(document.querySelector('[data-variant-id]').value);
    if (initialVariantId) {
      var initialVariant = variantData.find(function(v) { return v.id === initialVariantId; });
      if (initialVariant) {
        updateOptionAvailability(getSelectedOptions());
        updateGapNote();
        updateSelectedLabels();
        updatePrice(initialVariant);
        updateLeadTime(initialVariant);
        updateCartLeadTime(initialVariant);
        updateMtoNote(initialVariant);
        updateFineness(initialVariant);
        filterGalleryBySku(initialVariant, true);
      }
    }

    /* --- Combined "Material & Größe" split control --- */
    /* The Liquid above renders a metal row + size row for single-option
       products whose values read "<metal> · <sizeLabel>", and hides the flat
       radio list. This block gives the split controls their behaviour. The
       hidden radios stay the ONE source of truth: a (metal, size) pick
       resolves to its radio, checks it and fires its native change event, so
       handleOptionChange (price, lead time, gallery, ATC, URL, hidden
       variant-id input) runs exactly as if the flat list had been clicked.
       If the values do not parse the way the Liquid assumed, the split UI is
       dropped and the flat list is revealed — never a dead picker. */
    (function() {
      var combinedEl = productEl.querySelector('[data-combined]');
      if (!combinedEl) return;
      var fallbackEl = productEl.querySelector('.product__option--js-fallback');
      var optIdx = parseInt(combinedEl.dataset.combinedOptionIndex);
      var metalRe = /wei(?:ß|ss)gold|gelbgold|rotgold|ros[eé]gold|platin|silber/i;

      function bail() {
        combinedEl.hidden = true;
        if (fallbackEl) fallbackEl.classList.remove('product__option--js-fallback');
      }

      /* (metal, size) → underlying radio, parsed from the radio values so the
         mapping can never drift from what the form actually submits. */
      var baseInputs = Array.prototype.slice.call(
        productEl.querySelectorAll('[data-option-index="' + optIdx + '"]')
      );
      var pairs = [];
      for (var b = 0; b < baseInputs.length; b++) {
        var parts = baseInputs[b].value.split(' · ');
        if (parts.length !== 2) { pairs = null; break; }
        var m0 = metalRe.test(parts[0]);
        var m1 = metalRe.test(parts[1]);
        if (m0 === m1) { pairs = null; break; }
        pairs.push({
          metal: m0 ? parts[0] : parts[1],
          size: m0 ? parts[1] : parts[0],
          input: baseInputs[b]
        });
      }
      if (!pairs || pairs.length === 0) { bail(); return; }

      var metalInputs = Array.prototype.slice.call(combinedEl.querySelectorAll('[data-combined-metal]'));
      var sizeInputs = Array.prototype.slice.call(combinedEl.querySelectorAll('[data-combined-size]'));
      var metalEcho = combinedEl.querySelector('[data-combined-selected-metal]');
      var sizeEcho = combinedEl.querySelector('[data-combined-selected-size]');
      if (!metalInputs.length || !sizeInputs.length) { bail(); return; }

      /* The sizes are radios, or the <option>s of a select (more than 8 sizes). */
      var sizeSelect = combinedEl.querySelector('[data-combined-size-select]');
      function isOn(el) { return el.tagName === 'OPTION' ? el.selected : el.checked; }
      function setOn(el, on) { if (el.tagName === 'OPTION') el.selected = on; else el.checked = on; }

      function checkedValue(inputs) {
        for (var i = 0; i < inputs.length; i++) {
          if (isOn(inputs[i])) return inputs[i].value;
        }
        return '';
      }

      function pairFor(metal, size) {
        for (var i = 0; i < pairs.length; i++) {
          if (pairs[i].metal === metal && pairs[i].size === size) return pairs[i];
        }
        return null;
      }

      function isBuyable(pair) {
        return !!pair && variantData.some(function(v) {
          return [v.option1, v.option2, v.option3][optIdx] === pair.input.value && v.available;
        });
      }

      /* A metal without a buyable variant stays visible, struck and not selectable. */
      metalInputs.forEach(function(mi) {
        var off = !pairs.some(function(p) { return p.metal === mi.value && isBuyable(p); });
        mi.disabled = off;
        var label = mi.closest('.product__option-value');
        if (label) label.classList.toggle('product__option-value--unavailable', off);
        markUnavailable(mi, off);
      });

      /* Sizes that do not exist for the chosen metal are disabled (kept
         visible so the range reads as one scale across metals). If the
         current size vanished with the metal switch, the first size the
         metal does have takes over — mirroring autoCorrectOptions(). */
      function syncSizes() {
        var metal = checkedValue(metalInputs);
        var hasCurrent = false;
        sizeInputs.forEach(function(si) {
          var exists = isBuyable(pairFor(metal, si.value));
          si.disabled = !exists;
          var label = si.closest('.product__option-value');
          if (label) label.classList.toggle('product__option-value--unavailable', !exists);
          if (si.tagName !== 'OPTION') markUnavailable(si, !exists);
          if (exists && isOn(si)) hasCurrent = true;
        });
        if (!hasCurrent) {
          for (var i = 0; i < sizeInputs.length; i++) {
            if (!sizeInputs[i].disabled) { setOn(sizeInputs[i], true); break; }
          }
        }
      }

      /* Echo the chip's DISPLAYED text, not the raw value: the size chips have
         a shared leading word ("Weite") stripped because it is already the row
         label — the echo must not reintroduce it ("WEITE Weite 50"). */
      function checkedLabelText(inputs) {
        for (var i = 0; i < inputs.length; i++) {
          if (!isOn(inputs[i])) continue;
          if (inputs[i].tagName === 'OPTION') return inputs[i].textContent;
          var label = inputs[i].closest('.product__option-value');
          var text = label && label.querySelector('.product__option-value-text');
          return text ? text.textContent : inputs[i].value;
        }
        return '';
      }

      function updateEchoes() {
        if (metalEcho) metalEcho.textContent = checkedLabelText(metalInputs);
        if (sizeEcho) sizeEcho.textContent = checkedLabelText(sizeInputs);
      }

      function commit() {
        var pair = pairFor(checkedValue(metalInputs), checkedValue(sizeInputs));
        updateEchoes();
        if (!pair || pair.input.checked) return;
        pair.input.checked = true;
        /* Native-shaped, bubbling change so the direct listener above AND any
           delegated document-level listeners (analytics) both fire. */
        pair.input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      metalInputs.forEach(function(mi) {
        mi.addEventListener('change', function() {
          syncSizes();
          updateGapNote();
          commit();
        });
      });
      if (sizeSelect) sizeSelect.addEventListener('change', commit);
      else sizeInputs.forEach(function(si) {
        si.addEventListener('change', commit);
      });

      /* Init from whichever radio Liquid rendered as checked, so split UI,
         flat list and the hidden variant-id input agree on first paint. */
      var initInput = null;
      for (var j = 0; j < baseInputs.length; j++) {
        if (baseInputs[j].checked) { initInput = baseInputs[j]; break; }
      }
      var initPair = null;
      for (var k = 0; k < pairs.length; k++) {
        if (pairs[k].input === initInput) { initPair = pairs[k]; break; }
      }
      if (initPair) {
        metalInputs.forEach(function(mi) { mi.checked = mi.value === initPair.metal; });
        sizeInputs.forEach(function(si) { setOn(si, si.value === initPair.size); });
      }
      syncSizes();
      /* A link to a variant that is not offered: syncSizes moved the chip, the form follows. */
      commit();
      updateEchoes();
      updateGapNote();
    })();

    /* --- Sticky mobile Add-to-Cart bar --- */
    var stickyBar = document.querySelector('[data-sticky-atc]');
    var mainAtc = document.querySelector('[data-add-to-cart]');
    var stickyBtn = document.querySelector('[data-sticky-atc-btn]');
    if (stickyBar && mainAtc && 'IntersectionObserver' in window) {
      /* The bar may only show once the real add-to-cart button has scrolled
         ABOVE the viewport — never while it is merely still below the fold.
         The old observer treated both cases the same, so on a 1000x600 or
         1023x700 window, where the button starts ~1100px down the page, the
         bar stood there at scroll 0 and covered the bottom 62px of the photo
         and the thumbnails (measured 2026-09-15).

         MECHANIC: the root is the viewport extended far DOWNWARDS, so
         "somewhere below the fold" counts as intersecting and the only state
         change left is the button leaving past the TOP edge. One crossing
         instead of two, and it also survives a jump that skips the button
         entirely (End key, in-page anchor, restored scroll position) — a plain
         viewport observer fires for none of those, because not-intersecting
         never changes, and the bar would stay in the wrong state.
         The rect check is the guard for a button that is not rendered at all
         (display:none gives an all-zero rect, which must not read as
         "scrolled past"). */
      /* The bar also leaves while the footer is on screen: at the page end it
         covered the payment icons and the legal links (review 2026-10-31). */
      var scrolledPast = false;
      var footerVisible = false;
      function syncStickyBar() {
        /* aria-hidden + inert are toggled together: aria-hidden keeps the bar
           out of the screen-reader tree, inert keeps its button out of the
           tab order. The CSS above says the same thing with `visibility`, so
           a keyboard user is never dropped onto the off-screen copy even if
           one of the two layers fails to load. */
        if (scrolledPast && !footerVisible) {
          stickyBar.classList.add('product__sticky-atc--visible');
          stickyBar.setAttribute('aria-hidden', 'false');
          stickyBar.removeAttribute('inert');
        } else {
          stickyBar.classList.remove('product__sticky-atc--visible');
          stickyBar.setAttribute('aria-hidden', 'true');
          stickyBar.setAttribute('inert', '');
        }
      }
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        });
        syncStickyBar();
      }, { rootMargin: '0px 0px 20000px 0px', threshold: 0 });
      io.observe(mainAtc);
      var siteFooter = document.querySelector('footer.footer');
      if (siteFooter) {
        new IntersectionObserver(function(entries) {
          footerVisible = entries[entries.length - 1].isIntersecting;
          syncStickyBar();
        }).observe(siteFooter);
      }

      if (stickyBtn) {
        stickyBtn.addEventListener('click', function() {
          if (mainAtc.disabled) return;
          mainAtc.scrollIntoView({ behavior: 'smooth', block: 'center' });
          /* Submit after a short delay so the user can confirm the variant. A click, not
             requestSubmit: the click is what Umami counts as add_to_cart (snippets/umami.liquid). */
          setTimeout(function() { mainAtc.click(); }, 250);
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mobileQuery = window.matchMedia('(max-width: 749px)');

    document.querySelectorAll('.reviews').forEach(function (container) {
      var track = container.querySelector('[data-carousel-track]');
      if (!track) return;

      var cards = Array.prototype.slice.call(track.querySelectorAll('.reviews__card'));
      if (!cards.length) return;

      /* Distance from one card to the next, read from the layout so it stays
         right at every breakpoint — card widths live in CSS, not here. */
      function step() {
        if (cards.length > 1) return cards[1].offsetLeft - cards[0].offsetLeft;
        return cards[0].offsetWidth;
      }

      /* Mobile centre-focus: the card nearest the middle of the track is full
         size, its neighbours recede. offsetLeft is relative to the track, which
         is position: relative, so it shares an origin with scrollLeft.
         Paging and the disabled state are NOT handled here — they come from
         snippets/carousel-nav.liquid, the one implementation all four carousel
         sections share. */
      function paintFocus() {
        if (!mobileQuery.matches) return;
        var center = track.scrollLeft + track.clientWidth / 2;
        var unit = step() || 1;
        cards.forEach(function (card) {
          var distance = Math.abs(center - (card.offsetLeft + card.offsetWidth / 2));
          var progress = Math.min(distance / unit, 1);
          card.style.transform = 'scale(' + (1 - progress * 0.12) + ')';
          card.style.opacity = 1 - progress * 0.4;
        });
      }

      var frame = null;
      function schedule() {
        if (frame) return;
        frame = requestAnimationFrame(function () {
          frame = null;
          paintFocus();
        });
      }

      track.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', schedule);
      }

      schedule();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["withdrawal-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.getElementById('withdrawal-form');
    if (!form) return;

    var submit = document.getElementById('withdrawal-submit');
    var formError = document.getElementById('withdrawal-form-error');
    var success = document.getElementById('withdrawal-success');
    var endpoint = form.dataset.endpoint;
    var fallbackEmail = form.dataset.fallbackEmail;

    var FIELDS = ['name', 'orderNumber', 'email', 'orderDate', 'message'];
    var ERROR_IDS = {
      name: 'withdrawal-name-error',
      orderNumber: 'withdrawal-order-error',
      email: 'withdrawal-email-error',
      orderDate: 'withdrawal-date-error',
      message: 'withdrawal-message-error'
    };

    // Same three rules as the worker (withdrawal/src/validate.ts); length limits
    // stay server-side. Returns [] when the form may be sent.
    function validate() {
      var errors = [];
      if (!form.elements.name.value.trim()) {
        errors.push({ field: 'name', message: form.dataset.msgName });
      }
      if (!form.elements.orderNumber.value.trim()) {
        errors.push({ field: 'orderNumber', message: form.dataset.msgOrder });
      }
      var email = form.elements.email;
      if (!email.value.trim()) {
        errors.push({ field: 'email', message: form.dataset.msgEmail });
      } else if (email.validity && email.validity.typeMismatch) {
        errors.push({ field: 'email', message: form.dataset.msgEmailInvalid });
      }
      return errors;
    }

    function clearErrors() {
      formError.hidden = true;
      formError.textContent = '';
      FIELDS.forEach(function (f) {
        var el = document.getElementById(ERROR_IDS[f]);
        if (el) {
          el.hidden = true;
          el.textContent = '';
        }
        var input = form.elements[f];
        if (input) input.removeAttribute('aria-invalid');
      });
    }

    function showErrors(errors) {
      var firstInput = null;
      var labels = [];
      var general = [];
      errors.forEach(function (e) {
        var target = document.getElementById(ERROR_IDS[e.field]);
        var input = form.elements[e.field];
        if (target && input) {
          target.textContent = e.message;
          target.hidden = false;
          input.setAttribute('aria-invalid', 'true');
          labels.push(input.dataset.label || e.field);
          if (!firstInput) firstInput = input;
        } else {
          // Field-less error (rate limit, storage failure) — belongs at the top.
          general.push(e.message);
        }
      });
      // One summary on top, role="alert": the field list for field errors, the
      // message itself for anything the server could not tie to a field.
      var lines = general.slice();
      if (labels.length) lines.unshift(form.dataset.msgSummary + ' ' + labels.join(', ') + '.');
      formError.textContent = lines.join(' ');
      formError.hidden = false;
      // Move the caret to the first problem instead of leaving the customer to
      // hunt for it; the message is already tied to the input via aria-describedby.
      if (firstInput) firstInput.focus();
      else formError.focus();
    }

    function showSuccess(reference, mailed) {
      form.hidden = true;
      var confirmSentence = mailed
        ? 'Eine Eingangsbestätigung ist an Ihre E-Mail-Adresse unterwegs.'
        : 'Die Eingangsbestätigung per E-Mail konnte gerade nicht zugestellt werden — wir senden sie unverzüglich nach. Ihr Widerruf ist davon unberührt und bei uns eingegangen.';
      var body = document.createElement('div');
      var title = document.createElement('h2');
      title.className = 'withdrawal__success-title';
      title.textContent = 'Ihr Widerruf ist eingegangen.';
      var ref = document.createElement('p');
      var strong = document.createElement('strong');
      strong.textContent = reference;
      ref.appendChild(document.createTextNode('Vorgangsnummer '));
      ref.appendChild(strong);
      ref.appendChild(document.createTextNode('. ' + confirmSentence));
      var next = document.createElement('p');
      next.textContent = 'Bitte senden Sie die Ware innerhalb von vierzehn Tagen zurück. ' +
        'Die Kosten der Rücksendung tragen wir; die Unterlagen dafür schicken wir Ihnen zu.';
      body.appendChild(title);
      body.appendChild(ref);
      body.appendChild(next);
      success.textContent = '';
      success.appendChild(body);
      success.hidden = false;
      success.focus();
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearErrors();

      var invalid = validate();
      if (invalid.length) {
        showErrors(invalid);
        return;
      }

      submit.disabled = true;

      var payload = {};
      FIELDS.concat(['website']).forEach(function (f) {
        var el = form.elements[f];
        payload[f] = el ? el.value : '';
      });

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { status: res.status, data: data };
          });
        })
        .then(function (r) {
          if (r.data && r.data.ok) {
            showSuccess(r.data.reference, r.data.confirmationMailed !== false);
            return;
          }
          submit.disabled = false;
          showErrors((r.data && r.data.errors) || [{
            field: '_',
            message: 'Ihr Widerruf konnte nicht übermittelt werden. Bitte senden Sie ihn an ' + fallbackEmail + '.'
          }]);
        })
        .catch(function () {
          // Network failure: the declaration certainly did not reach us, so the
          // customer must be handed a route that does not depend on this page.
          submit.disabled = false;
          showErrors([{
            field: '_',
            message: 'Die Verbindung ist fehlgeschlagen. Bitte senden Sie Ihren Widerruf an ' + fallbackEmail + ' — Ihre Frist ist gewahrt, sobald Sie ihn abgesendet haben.'
          }]);
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
